import { render, staticRenderFns } from "./MenuSuperUser.vue?vue&type=template&id=ebaf64de&scoped=true&"
import script from "./MenuSuperUser.vue?vue&type=script&lang=js&"
export * from "./MenuSuperUser.vue?vue&type=script&lang=js&"
import style0 from "./MenuSuperUser.vue?vue&type=style&index=0&id=ebaf64de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebaf64de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VDivider,VIcon,VList,VMenu})
